import { defineMessages } from 'react-intl';

const scope = 't.component.PortalNoElementFound';

export default defineMessages({
  defaultMessage: {
    id: `${scope}.defaultMessage`
  }
})
